import { useWidgetFormProvideInject } from '@/composition/widgetForm'
import { computed } from '@/composition/vue/compositionApi'

export const getWidgetFieldProps = <T = string>(name: string) => {
  const widgetForm = useWidgetFormProvideInject().inject()

  const modelValue = widgetForm?.form?.[name] as T
  const errors = widgetForm?.errors?.[name]

  const hasError = (errors && errors.length > 0) || false
  const errorMessage = errors?.[0] || ''

  const readonly = !widgetForm || widgetForm.config?.readonly || false

  const updateValue = (value: string | number | null) => widgetForm?.setFieldValue?.(name, String(value))
  const validate = () => widgetForm?.validateField?.(name)

  return {
    modelValue,
    hasError,
    errorMessage,
    readonly,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'onUpdate:model-value': updateValue,
    onBlur: validate,
  }
}

export const getReactiveWidgetFieldProps = <T = string>(name: string) => {
  const widgetForm = useWidgetFormProvideInject().inject()

  const modelValue = computed(() => widgetForm?.form?.[name] as T)
  const errors = computed(() => widgetForm?.errors?.[name])

  const hasError = computed(() => (errors.value && errors.value.length > 0) || false)
  const errorMessage = computed(() => errors.value?.[0] || '')

  const readonly = !widgetForm || widgetForm.config?.readonly || false

  const updateValue = (value: string | boolean | number | null) => {
    widgetForm?.setFieldValue?.(name, value)
  }
  const validate = () => widgetForm?.validateField?.(name)

  return {
    modelValue,
    hasError,
    errorMessage,
    readonly,
    onUpdate: updateValue,
    onBlur: validate,
  }
}
